/**
 * Appends CDN resizing params to a restaurant logo URL to optimize LCP
 */
export const getLogoImageUrl = (origImageUrlString: string): string => {
  try {
    const imageUrl = new URL(origImageUrlString);
    imageUrl.searchParams.set('width', '80');
    imageUrl.searchParams.set('quality', '85');
    imageUrl.searchParams.set('format', 'auto');
    return imageUrl.toString();
  } catch {
    return origImageUrlString;
  }
};
